import React from 'react';
import { Typography } from '../design-system/typography';
import { colors, spacing } from '../design-system/tokens';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode; // Action buttons (Edit, Save, Cancel)
  className?: string;
  showBottomBorder?: boolean;
  style?: React.CSSProperties;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ 
  title, 
  subtitle,
  icon, 
  actions,
  className = '',
  showBottomBorder = false,
  style = {}
}) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between', // Space between title and actions
        gap: spacing.md,
        paddingBottom: showBottomBorder ? spacing.sm : 0,
        borderBottom: showBottomBorder ? `1px solid ${colors.border.default}` : 'none',
        ...style
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: spacing.md }}>
        {icon && (
          <div
            style={{
              color: colors.text.secondary,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </div>
        )}
        <div>
          <Typography 
            variant="h1" 
            style={{ 
              color: colors.text.primary,
              margin: 0
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography 
              variant="cardSubtitle" 
              style={{ 
                color: colors.text.secondary,
                margin: 0,
                marginTop: spacing.xs
              }}
            >
              {subtitle}
            </Typography>
          )}
        </div>
      </div>
      {actions && (
        <div style={{ display: 'flex', gap: spacing.sm }}>
          {actions}
        </div>
      )}
    </div>
  );
};

export const SubsectionHeader: React.FC<{ title: string; className?: string }> = ({ 
  title, 
  className = '' 
}) => {
  return (
    <Typography 
      variant="h2" 
      className={className}
      style={{ 
        color: colors.text.primary, 
        marginBottom: spacing.lg
      }}
    >
      {title}
    </Typography>
  );
};